export type FieldErrors = Record<string, string[]>;

export type ApiResponse<T> = {
  status: boolean;
  statusCode: number;
  message: string;
  data: T | null;
  errors: FieldErrors | null;
} & Record<string, unknown>;

const toNumber = (v: unknown, fallback = 0) => {
  if (typeof v === "number") return v;
  if (typeof v === "string") {
    const n = Number(v);
    return Number.isFinite(n) ? n : fallback;
  }
  return fallback;
};

const isObject = (v: unknown): v is Record<string, unknown> =>
  typeof v === "object" && v !== null;

export const normalizeApiResponse = <T>(
  raw: unknown,
  httpStatusFallback = 200,
): ApiResponse<T> => {
  // 1) Envelope case: { status, statusCode, message, data, errors }
  if (isObject(raw)) {
    const hasEnvelopeSignal =
      typeof raw.status === "boolean" ||
      "statusCode" in raw ||
      "errors" in raw ||
      "message" in raw;

    const hasDataKey = "data" in raw || "Data" in raw;

    if (hasEnvelopeSignal && hasDataKey) {
      const data = (raw.data ?? (raw as any).Data ?? null) as T | null;
      const errors = (raw.errors ??
        (raw as any).Errors ??
        null) as FieldErrors | null;

      return {
        ...(raw as Record<string, unknown>),
        status: Boolean(raw.status),
        statusCode: toNumber(
          raw.statusCode ??
            (raw as any).status_code ??
            (raw as any).code ??
            httpStatusFallback,
        ),
        message: String(raw.message ?? ""),
        data,
        errors,
      };
    }

    // 2) Direct payload case: { userId, token, ... }  => treat as success data
    return {
      status: true,
      statusCode: httpStatusFallback,
      message: "",
      data: raw as T,
      errors: null,
    };
  }

  // 3) Non-object raw (unexpected)
  return {
    status: false,
    statusCode: httpStatusFallback,
    message: "Invalid server response.",
    data: null,
    errors: null,
  };
};

export type ServiceCallResult<T> =
  | { ok: true; value: T; raw: ApiResponse<T> }
  | {
      ok: false;
      message: string;
      statusCode: number;
      errors: FieldErrors | null;
      raw?: ApiResponse<unknown>;
    };

// export type FieldErrors = Record<string, string[]>;

// export type ServerResponse<T> = {
//   status: boolean;
//   statusCode: number;
//   message: string;
//   data: T | null;
//   errors: FieldErrors | null;

//   // future me backend extra fields add karega to yaha safe rahega
// } & Record<string, unknown>;

// const toNumber = (v: unknown, fallback = 0) => {
//   if (typeof v === "number") return v;
//   if (typeof v === "string") {
//     const n = Number(v);
//     return Number.isFinite(n) ? n : fallback;
//   }
//   return fallback;
// };

// export const normalizeServerResponse = <T>(raw: unknown): ServerResponse<T> => {
//   const r = (raw ?? {}) as Record<string, unknown>;

//   // backend kabhi Data / Errors bhi bhej sakta hai, isliye fallback rakha
//   const data = (r.data ?? r.Data ?? null) as T | null;
//   const errors = (r.errors ?? r.Errors ?? null) as FieldErrors | null;

//   return {
//     ...(r as Record<string, unknown>),
//     status: Boolean(r.status),
//     statusCode: toNumber(r.statusCode ?? r.status_code ?? r.code ?? 0),
//     message: String(r.message ?? ""),
//     data,
//     errors,
//   };
// };

// export type ServiceCallResult<T> =
//   | { ok: true; value: T; raw: ServerResponse<T> }
//   | { ok: false; message: string; statusCode: number; errors: FieldErrors | null; raw?: ServerResponse<unknown> };
